
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPurRequestDtGrid extends Serenity.EntityGrid<PoPurRequestDtRow, any> {
        protected getColumnsKey() { return PoPurRequestDtColumns.columnsKey; }
        protected getDialogType() { return PoPurRequestDtDialog; }
        protected getIdProperty() { return PoPurRequestDtRow.idProperty; }
        protected getInsertPermission() { return PoPurRequestDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PoPurRequestDtRow.localTextPrefix; }
        protected getService() { return PoPurRequestDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected beforeLoadEntity() {
            let self = this;            

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }
    }
}